import React, { CSSProperties } from 'react'
import { browserCheck } from '@ta-interaktiv/browsercheck'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
// Image with Mobile-Desktop-Switch

export interface LinkProps {
  /** Url to open  */
  href?: string
  icon?: string
  /** hide the icon  */
  hideIcon?: boolean | false
  /** Link target  */
  target?: [string, string] | string
  /** CSS-Class for Link */
  className?: string
  /** Inline css for the link */
  style?: CSSProperties
  children?: string | React.ReactNode
  [key: string]: any
}

export const Articlelink = ({
  href = '',
  children,
  icon = 'external alternate',
  hideIcon = false,
  target = ['_parent', '_blank'],
  className = 'cbLink',
  style = {},
  ...props
}: LinkProps) => {
  if (!children && href) children = href

  var openIn: string
  if (typeof target === 'object') {
    if (browserCheck.isMobile) {
      openIn = target[0]
    } else {
      openIn = target[1]
    }
  } else {
    openIn = target
  }
  return (
    <div style={{ display: 'flex' }}>
      <a
        href={href}
        target={openIn}
        className={className}
        style={{
          ...style,
          ...(!children ? { color: '#EB0000' } : {}),
          ...{ display: 'flex' }
        }}
        {...props}
      >
        <div style={{ float: 'left', height: '100%' }}>
          {!hideIcon && (
            <i className={'icon ' + icon || 'external alternate'} />
          )}
        </div>
        <div>{children || 'Linktext'}</div>
      </a>
    </div>
  )
}

Articlelink.defaultProps = {
  href: '',
  icon: 'external alternate',
  hideIcon: false,
  target: ['_parent', '_blank'],
  className: 'cbLink'
}
